export const siteConfig = {
  name: 'Axolmen',
  url: 'https://www.axolmen.com',
  description:
    'Axolmen: Marca 100% mexicana que ofrece moda de calidad con una experiencia de compra única. Descubre un estilo global diseñado con detalles que resaltan tu identidad.',
  category: 'cloting',
  icon: '/axolmen.png',
  iconBlack: '/axolmen-black.png',
  landscapeLogo: '/Axolmen-horizontal.png',
  baseLinks: {
    home: '/',
    about: '/about',
    termsAndConditions: '/terms-and-conditions',
    shop: '/shop',
    checkout: '/checkout/address',
    dashboard: '/dashboard',
    profile: '/profile',
    products: '/dashboard/products',
    users: '/dashboard/users',
    orders: '/orders',
    collections: '/dashboard/collections',
    emails: '/dashboard/emails',
    signIn: '/sign-in',
    signUp: '/sign-up',
    categories: '/categories',
    currentColletion: '/current-collection',
    ordersAdmin: '/dashboard/orders',
    stock: '/dashboard/stock',
    categoriesAdmin: '/dashboard/categories'
  },
  socials: {
    tiktok: 'https://www.tiktok.com/@axolmen',
    instagram:
      'https://www.instagram.com/axolmen.mx/profilecard/?igsh=MWwxN3lsbjA0a2JlZQ=='
  },
  isFreeShipping: '$750'
}

export type siteConfig = typeof siteConfig
